import React from 'react';

export default function Card({ variant = 'default', className = '', children }) {
  const base = 'yk-card';
  const variantClass = variant ? `yk-card--${variant}` : '';

  return <div className={[base, variantClass, className].filter(Boolean).join(' ')}>{children}</div>;
}
